import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonCs from './locales/cs/common.json';
import authCs from './locales/cs/auth.json';
import ordersCs from './locales/cs/orders.json';
import usersCs from './locales/cs/users.json';
import adminCs from './locales/cs/admin.json';
import placesCs from './locales/cs/places.json';

// i18n init — Czech only in MVP (NF-04). Namespaces split per feature so a
// missing key in `orders` doesn't accidentally fall back to a same-named key
// in `common`. Adding English later is a matter of dropping en/* files and
// flipping the language detector.
void i18n.use(initReactI18next).init({
  lng: 'cs',
  fallbackLng: 'cs',
  defaultNS: 'common',
  ns: ['common', 'auth', 'orders', 'users', 'admin', 'places'],
  resources: {
    cs: {
      common: commonCs,
      auth: authCs,
      orders: ordersCs,
      users: usersCs,
      admin: adminCs,
      places: placesCs,
    },
  },
  interpolation: {
    escapeValue: false, // React already escapes
  },
  returnNull: false,
});

export default i18n;
